<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-down`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.83594 9.89128C7.94217 9.92817 8.05783 9.92816 8.16406 9.89128C8.28533 9.84904 8.3888 9.73435 8.59473 9.50554L10.3984 7.50163C10.779 7.07873 10.969 6.86699 10.9766 6.68718C10.9831 6.53097 10.9164 6.38058 10.7959 6.28093C10.6572 6.16626 10.3727 6.16667 9.80371 6.16667H6.19629C5.62731 6.16667 5.34279 6.16622 5.2041 6.28093C5.08363 6.38058 5.01692 6.53097 5.02344 6.68718C5.03102 6.86699 5.22096 7.07873 5.60156 7.50163L7.40528 9.50554C7.61121 9.73435 7.71467 9.84904 7.83594 9.89128Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillDown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
